import isNil from 'lodash/isNil'
import {
  AGENT_ASSESSMENT_RISK_SECTION,
  generateRequestDetailRoute,
  generateRequestRiskSectionRoute,
  RequestTabs,
} from '@omnea-app/fe-requests/requestRoutes'
import { RequestStepTaskTypeEnum } from '@omnea-app/packages/universal/hasura/graphql'
import { isAgentAssessmentBlockType } from '@omnea-app/packages/universal/workflow/isAgentAssessmentBlockType'
import { BlockTypeEnum } from '@omnea-app/packages/universal/workflow/model/utils/blocks'
import { TaskRow } from './useTaskTableRows'

export const getTaskRequestLink = (task: TaskRow): string | null => {
  if (task.globalSubtype === 'APPROVE_BILL') {
    return isNil(task.billId) ? null : `/bills/detail/${task.billId}`
  }

  if (isNil(task.requestId)) {
    return null
  }

  if (task.globalSubtype === 'CONFIRM_GOODS_RECEIVED') {
    return generateRequestDetailRoute(RequestTabs.LINE_ITEMS, task.requestId)
  }

  if (task.stageType === BlockTypeEnum.RFX) {
    // One active round per step: setup and scoring are never both open.
    if (task.activeSubTaskTypes.includes(RequestStepTaskTypeEnum.RFX_SETUP)) {
      return generateRequestDetailRoute(RequestTabs.RFX, task.requestId)
    }
    return `/requests/detail/${task.requestId}/rfx/evaluation/responses`
  }

  if (task.stageType === BlockTypeEnum.EXTERNAL_OPERATION) {
    const hasStepLevelAssignees = (task.currentUserAssignees?.length ?? 0) > 0 || (task.currentGroupAssignees?.length ?? 0) > 0
    if (hasStepLevelAssignees) {
      const activeTaskId = task.activeSubTaskIds.length > 0 ? task.activeSubTaskIds[0] : undefined
      return generateRequestDetailRoute(RequestTabs.MY_TASKS, task.requestId, activeTaskId)
    }
    return generateRequestDetailRoute(RequestTabs.OVERVIEW, task.requestId)
  }

  if (isAgentAssessmentBlockType(task.stageType)) {
    const activeTaskId = task.activeSubTaskIds[0]
    return isNil(activeTaskId)
      ? generateRequestRiskSectionRoute(task.requestId, AGENT_ASSESSMENT_RISK_SECTION[task.stageType])
      : generateRequestDetailRoute(RequestTabs.MY_TASKS, task.requestId, activeTaskId)
  }

  const requestTab = task.stageType === BlockTypeEnum.INTAKE ? RequestTabs.INTAKE_FORM : RequestTabs.MY_TASKS
  const activeTaskId = task.activeSubTaskIds.length > 0 ? task.activeSubTaskIds[0] : undefined

  return generateRequestDetailRoute(requestTab, task.requestId, activeTaskId)
}
